import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NbDialogRef, NbDialogService } from '@nebular/theme';
import { ContentElement, ContentElementEnum, ContentEnum, ContentStatusEnum, GridCell, RowCell, Section } from '@urbannex/storethemes';
import { SectionBuilderStoreService } from '../section-builder-store.service';
import { SampleImageDirectoryComponent } from '../../../sample-image-directory/sample-image-directory.component';
import { ImageEditorComponent } from '../section-builder-editors/image-editor/image-editor.component';
import { ProductEditorDialogComponent } from '../../../dialogs/product-editor-dialog/product-editor-dialog.component';
import { OfbizFormsService } from '@urbannex/ofbiz-forms';
import { Subject, combineLatest, takeUntil } from 'rxjs';
import { ConfigurationService } from '@urbannex/configuration';



@Component({
  selector: 'ngx-section-cell-stepper',
  templateUrl: './section-cell-stepper.component.html',
  styleUrls: ['./section-cell-stepper.component.scss']
})
export class SectionCellStepperComponent implements OnInit, OnDestroy{
  @Input() cell:GridCell | RowCell;
  @Input() section:Section; 
  contentEnum:ContentEnum;
  stepperTitle:string;
  contentElements:ContentElement[];

  cntElementEnum = ContentElementEnum;

  currentCntElementEnum:ContentElementEnum;

  showPlaceholder: boolean = true;

  imgSrc: string;

  lastStep = false;
  firstStep = true;

  baseUrl:string;

  private destroy$ = new Subject<void>();
  
  constructor(
    protected ref: NbDialogRef<SectionCellStepperComponent>,
    private sectionBuilderStoreService:SectionBuilderStoreService,
    private dialogService: NbDialogService,
    private ofbizFormsService:OfbizFormsService,
    private configurationService:ConfigurationService,){}
  
  
  
  ngOnInit(): void {
    this.baseUrl = this.configurationService.getBaseUrl();
    console.log(this.cell);
    this.contentEnum = this.cell.contentEnum;
    this.stepperTitle = this.getStepperTitle(this.contentEnum)
    this.contentElements = this.cell.contentElements;

    //this.sectionBuilderStoreService.updateSelectedCell(this.cell);
    /* this.sectionBuilderStoreService.selectedCell$.subscribe(cell => {
      console.log(cell)
      this.cell = cell;
      this.contentEnum = cell.contentEnum;
      this.stepperTitle = this.getStepperTitle(this.contentEnum)
      this.contentElements = this.cell.contentElements;
    }) */
    /* this.sectionBuilderStoreService.state$.subscribe(state => {
      console.log("Via state",state);
    }) */
    //this.contentEnum = this.cell.contentEnum;
    //console.log(this.contentEnum)
    
    
  }

  getStepperTitle(titleEnum){
    let title;
    if((titleEnum).includes(".")){
      let enumKey = titleEnum.split('.')[1] as keyof typeof ContentEnum;
      title = ContentEnum[enumKey];
    }else if(ContentEnum[titleEnum] != undefined){
      title = ContentEnum[titleEnum]
    }else{
      title = titleEnum;
    }
    
    console.log(title)
    
    return title;
  }

  onStepChange(e){
    if(e.index == (e.step.stepper.steps.length - 1)){
      this.lastStep = true;
    }
    if(e.index > 0){
      this.firstStep = false;
    }
  }

  getEnumValue(contentElement:ContentElement){
    let enumValue:string;
    let titleEnum = contentElement.contentElementEnum
    if(titleEnum != undefined){
      if((titleEnum).includes(".")){
        let enumKey = titleEnum.split('.')[1] as keyof typeof ContentElementEnum;
        enumValue = ContentElementEnum[enumKey];
      }else if(ContentElementEnum[titleEnum] != undefined){
        enumValue = ContentElementEnum[titleEnum]
      }else{
        enumValue = titleEnum;
      }
    }
    if(enumValue) enumValue = <string>enumValue.toUpperCase();
    
    return enumValue;
    /* console.log(titleEnum)
    let title;
    if((titleEnum).includes(".")){
      let enumKey = titleEnum.split('.')[1] as keyof typeof ContentElementEnum;
      title = ContentElementEnum[enumKey];
    }else if(ContentElementEnum[titleEnum] != undefined){
      title = ContentElementEnum[titleEnum]
    }else{
      title = titleEnum;
    }
    console.log(title)
    return title */
  }

  imageDialog(){
    this.dialogService.open(ImageEditorComponent, {
      context: {
        title: 'Gallery',
        section:this.section,
        //cellId:this.cell.cellId
      },
    }).onClose.subscribe(() => {
      this.sectionBuilderStoreService.selectedCell$.subscribe(data => {
        console.log(data);
        this.imgSrc = data.imgSrc;
        this.showPlaceholder = false;
      });
    })
  }

  onImageError() {
    this.showPlaceholder = true;
  }

  onChangeContentEl(elId,e){
    //console.log(e);
    let selectedEl = this.cell.contentElements.find(cntEl => cntEl.elId === elId);
    selectedEl.text = e;
  }

  onSubmitContent(){
    this.cell.status = ContentStatusEnum.CTNT_INITIAL_DRAFT;
    this.section.status = ContentStatusEnum.CTNT_INITIAL_DRAFT;
    this.sectionBuilderStoreService.updateSection(this.section);
    this.sectionBuilderStoreService.updateSelectedCell(this.cell);
    this.ref.close();
  }

  productDialog(mode:string){
    // ProductEditorDialogComponent
    "Opening productDialog - section"
    this.dialogService.open(ProductEditorDialogComponent, {
      closeOnBackdropClick:false,
      context:{
        mode:mode,
      }
    }).onClose.subscribe(resp => {
      const formData = resp["data"]["formData"];
      let link = formData["link"];
      const formName = formData["formName"];
      const formLocation = formData["formLocation"];
      const parts = link.split('/');
      const productId = parts[parts.length - 1]
      console.log(productId);
      combineLatest([
        this.ofbizFormsService.getValue(formData,{productId:productId},null),
        this.ofbizFormsService.getValue({formName:"ProductSummary",formLocation:"component://kwikstore/widget/ProductForms.xml"},{productId:productId},null)
      ]).pipe(
        takeUntil(this.destroy$)
      )
      .subscribe(([fieldsData,summaryData]:[any,any]) => {
        const formData = fieldsData["data"]["formData"];
        const fields = formData["fields"];
        this.populateContentElements(fields);
        const summary = summaryData["data"]["formData"]
        this.populateContentElements(summary["fields"]);
      })
      /* this.ofbizFormsService.getValue(formData,{productId:productId},null)
      .subscribe(resp => {
        const formData = resp["data"]["formData"];
        const fields = formData["fields"];
        this.populateContentElements(fields);
      }) */
    })
  }

  closeDialog(){
    this.ref.close()
  }
  /**
   * 
   * @param fields From backend used to populate contentElement values
   */
  populateContentElements(fields:any[]):void{
    console.log("running populateContentElements")
    //Product Name;
    //Price
    //Discount
    //Category
    //Release
    //Normal Price
    //Quick View
    //Release
    //Add to wish list
    //Add to cart
    console.log(this.contentElements);
    this.contentElements.forEach(contentElement => {
      if(contentElement.fieldName == "productName" || contentElement.name == "Product Name"){
        contentElement.text = this.getFieldValue("productName",fields);
        console.log(contentElement)
      }
      if(contentElement.fieldName == "price" || contentElement.name == "Price"){
        contentElement.text = this.getFieldValue("price",fields);
        console.log(contentElement)
      }
    })
    console.log(fields);
    //let productId = this.getFieldValue("productId",fields);
    //console.log(productId);
    let smallImageUrl = this.getFieldValue("smallImageUrl",fields);
    if(smallImageUrl != undefined){
      //clean url of htmlsafe characters
      smallImageUrl = decodeURIComponent(smallImageUrl);
      let baseUrl = this.baseUrl.replace("rest/","");
      this.imgSrc = baseUrl+smallImageUrl;
      this.cell.imgSrc = this.imgSrc;
      this.showPlaceholder = false;
      console.log(this.imgSrc)
    }
    //console.log(this.cell)
    //get the productSummary


  }

  getFieldValue(nameKey, fields){
    let value;
      for (let i=0; i < fields.length; i++) {
        for (let [k,v] of Object.entries(fields[i])) {
          if(k === nameKey){
            value =  fields[i][k];
          }
        }
      }
    return value
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }


}


